import { Locale } from "@/Common/Models/Localization/Locale";
import { BaseObstetricalHistory, ObstetricalHistoryColumnTitle } from "@/Patient/Components/MedicalNote/Obstetric/Form/BaseObstetricalHistory";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileSection4 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        return (
            <div className="section border border-bottom">
                <div className="row flex-row padding-sm-top padding-sm-bottom padding-md-left padding-md-right">
                    {this.renderTitle(4, "AntecedentsObstetriquesLabel", "", { alignSelf: "center" })}
                    {this.props.renderObstetricalCounters("col-md-12")}
                </div>
                <BritishColumbiaObstetricalHistory
                    unit={this.props.form.Section4.ObstetricalHistoryMassUnit}
                    updatePreviousPregnancies={(newRows, triggerSave) => triggerSave
                        ? this.props.mutateModelStateWithFormUpdate(s => s.Section4.ObstetricalHistory = newRows)
                        : this.props.mutateModelState(s => s.Section4.ObstetricalHistory = newRows)
                    }
                    onMassUnitChange={(unit, pregnancies) => this.props.mutateModelStateWithFormUpdate(s => {
                        s.Section4.ObstetricalHistoryMassUnit = unit;
                        s.Section4.ObstetricalHistory = pregnancies;
                    })}
                    readonly={this.props.readonly}
                    previousPregnanciesRows={this.props.form.Section4.ObstetricalHistory}
                />
            </div>
        );
    }
}

class BritishColumbiaObstetricalHistory extends BaseObstetricalHistory {
    public componentWillMount(): void {
        super.componentWillMount();
        this.setAcceptableLocales([Locale.en]);
    }

    protected get columnsTitles(): { [index in ObstetricalHistoryColumnTitle]: React.ReactNode } {
        return {
            [ObstetricalHistoryColumnTitle.Date]: this.getString("DateLabel"),
            [ObstetricalHistoryColumnTitle.PlaceOfBirth]: this.getString("ObstetricalFileBc_PlaceOfBirthLabel"),
            [ObstetricalHistoryColumnTitle.GestationalAge]: this.getString("GestationAgeAbbreviationLabel"),
            [ObstetricalHistoryColumnTitle.DurationOfLabor]: <span>{this.getString("DurationOfLabourLabel")} <span className="extra-info-label">({this.getString("HoursAbbrevLabel")})</span></span>,
            [ObstetricalHistoryColumnTitle.BirthType]: this.getString("ObstetricalFile_ModeOfBirthLabel"),
            [ObstetricalHistoryColumnTitle.Comments]: this.getString("ObstetricalFile_PerinatalComplicationsCommentsLabel"),
            [ObstetricalHistoryColumnTitle.Sex]: this.getString("SexLabel"),
            [ObstetricalHistoryColumnTitle.BirthWeight]: this.getString("ObstetricalFileBc_BirthWeightLabel"),
            [ObstetricalHistoryColumnTitle.BreastfedDuration]: <span>{this.getString("BreastfedLabel")} <span className="extra-info-label">({this.getString("MonthsAbbrevLabel")})</span></span>,
            [ObstetricalHistoryColumnTitle.ChildPresentHealth]: this.getString("ObstetricalFile_ChildPresentHealthLabel")
        };
    }

    protected get columnMaxLength(): { [index in ObstetricalHistoryColumnTitle]: number | null } {
        return {
            [ObstetricalHistoryColumnTitle.Date]: null,
            [ObstetricalHistoryColumnTitle.PlaceOfBirth]: 12,
            [ObstetricalHistoryColumnTitle.GestationalAge]: null,
            [ObstetricalHistoryColumnTitle.DurationOfLabor]: 6,
            [ObstetricalHistoryColumnTitle.BirthType]: 10,
            [ObstetricalHistoryColumnTitle.Comments]: 5000,
            [ObstetricalHistoryColumnTitle.Sex]: 1,
            [ObstetricalHistoryColumnTitle.BirthWeight]: 5,
            [ObstetricalHistoryColumnTitle.BreastfedDuration]: 4,
            [ObstetricalHistoryColumnTitle.ChildPresentHealth]: null
        };
    }
}

export { BritishColumbiaObstetricalFileSection4 };
